<template>
  <div class="page-title">
    <router-link to="/">
      <YearBadge
        class="badge"
        :collection="collection"
      />
    </router-link>
    <!-- eslint-disable vue/no-v-html -->
    <h2 v-html="title" />
  </div>
</template>
<script>
import YearBadge from '@/components/common/badges/YearBadge.vue';

export default {
  name: 'PageTitle',
  components: {
    YearBadge,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    collection: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style lang="stylus" scoped>
.page-title {
  display: flex
  align-items: flex-start
  gap: 8px;
  margin: 0 15px;
  +mobile() {
    margin: 0 20px;
  }

  .badge {
    margin-top: 4px;
  }

  +mobile() {
    flex-direction: column;
  }
  h2 {
    margin: 0
    font-size: 38px
    display: flex;
    flex-direction: column;
    text-align: left;
    line-height: 1.1;
    max-width: calc(50vw - 75px);

    +mobile() {
      font-size: 28px;
      max-width: 450px;
      display: block;
      min-width: 270px;

      +below(280px) {
        font-size: 22px;
      }
    }

    +desktop() {
      b, strong, em {
        display: block;
      }
    }
  }
}
</style>
